export const GENERAL_EVENTS = [
  "PING",
  "BROKER_CREATED",
  "BROKER_UPDATED",
  "BROKER_DELETED",
  "CUSTOMER_CREATED",
  "CUSTOMER_UPDATED",
  "CUSTOMER_DELETED",
] as const
export const ORDER_EVENTS = [
  "ORDER_CREATED",
  "ORDER_PAID",
  "ORDER_EXPIRED",
  "ORDER_REVERSED",
  "ORDER_REVERSE_FAILED",
  "ORDER_REFUNDED",
  "ORDER_REFUND_FAILED",
  "ORDER_PARTIAL_REFUNDED",
  "ORDER_FINISHED",
  "ORDER_PAYMENT_FAILED",
] as const
export const SUBSCRIPTION_EVENTS = [
  "SUBSCRIPTION_CREATED",
  "SUBSCRIPTION_PAUSE",
  "SUBSCRIPTION_CANCELLED",
  "SUBSCRIPTION_FINISHED",
  "SUBSCRIPTION_EXPIRED",
  "SUBSCRIPTION_PAYMENT_METHOD_CHANGED",
] as const
export const SUBSCRIPTION_CYCLE_EVENTS = [
  "SUBSCRIPTION_CYCLE_PAID",
  "SUBSCRIPTION_CYCLE_REVERSED",
  "SUBSCRIPTION_CYCLE_REVERSE_FAILED",
  "SUBSCRIPTION_CYCLE_REFUNDED",
  "SUBSCRIPTION_CYCLE_REFUND_FAILED",
  "SUBSCRIPTION_CYCLE_PARTIAL_REFUNDED",
  "SUBSCRIPTION_CYCLE_CANCELLED",
  "SUBSCRIPTION_CYCLE_SKIPPED",
  "SUBSCRIPTION_CYCLE_PAYMENT_FAILED",
  "SUBSCRIPTION_CYCLE_WAITING_PAYMENT",
  "SUBSCRIPTION_CYCLE_PAYMENT_IDENTIFIED",
  "SUBSCRIPTION_CYCLE_PAYMENT_METHOD_CHANGED",
] as const
export const ORDER_INSURANCE_EVENTS = [
  "ORDER_INSURANCE_CREATED",
  "ORDER_INSURANCE_PAID",
  "ORDER_INSURANCE_EXPIRED",
  "ORDER_INSURANCE_REVERSED",
  "ORDER_INSURANCE_REVERSE_FAILED",
  "ORDER_INSURANCE_REFUNDED",
  "ORDER_INSURANCE_REFUND_FAILED",
  "ORDER_INSURANCE_REFUND_CANCELED",
  "ORDER_INSURANCE_REFUND_PENDING",
  "ORDER_INSURANCE_PARTIAL_REFUNDED",
  "ORDER_INSURANCE_FINISHED",
  "ORDER_INSURANCE_PAYMENT_FAILED",
  "ORDER_INSURANCE_WAITING_PAYMENT",
  "ORDER_INSURANCE_PAYMENT_IDENTIFIED",
] as const
export const SUBSCRIPTION_INSURANCE_EVENTS = [
  "SUBSCRIPTION_INSURANCE_CREATED",
  "SUBSCRIPTION_INSURANCE_PAUSE",
  "SUBSCRIPTION_INSURANCE_CANCELLED",
  "SUBSCRIPTION_INSURANCE_FINISHED",
  "SUBSCRIPTION_INSURANCE_EXPIRED",
  "SUBSCRIPTION_INSURANCE_PAYMENT_METHOD_CHANGED",
  "SUBSCRIPTION_INSURANCE_DELEGATE_REVIEW_EXPIRED",
  "SUBSCRIPTION_INSURANCE_DELEGATE_UNDER_REVIEW",
] as const
export const SUBSCRIPTION_INSURANCE_CYCLE_EVENTS = [
  "SUBSCRIPTION_INSURANCE_CYCLE_PAID",
  "SUBSCRIPTION_INSURANCE_CYCLE_REVERSED",
  "SUBSCRIPTION_INSURANCE_CYCLE_REVERSE_FAILED",
  "SUBSCRIPTION_INSURANCE_CYCLE_REFUNDED",
  "SUBSCRIPTION_INSURANCE_CYCLE_REFUND_FAILED",
  "SUBSCRIPTION_INSURANCE_CYCLE_PARTIAL_REFUNDED",
  "SUBSCRIPTION_INSURANCE_CYCLE_CANCELLED",
  "SUBSCRIPTION_INSURANCE_CYCLE_SKIPPED",
  "SUBSCRIPTION_INSURANCE_CYCLE_PAYMENT_FAILED",
  "SUBSCRIPTION_INSURANCE_CYCLE_WAITING_PAYMENT",
  "SUBSCRIPTION_INSURANCE_CYCLE_PAYMENT_IDENTIFIED",
  "SUBSCRIPTION_INSURANCE_CYCLE_PAYMENT_METHOD_CHANGED",
] as const
export const CARD_EVENTS = [
  "CARD_CREATED",
  "CARD_UPDATED",
  "CARD_DELETED",
  "CARD_EXPIRED",
] as const
export const ANTIFRAUD_EVENTS = [
  "PAYMENT_ANTIFRAUD_APPROVED",
  "PAYMENT_ANTIFRAUD_MANUAL",
  "PAYMENT_ANTIFRAUD_PENDING",
  "PAYMENT_ANTIFRAUD_REPROVED",
] as const
export const PAYMENT_EVENTS = [
  "PAYMENT_CREATED",
  "PAYMENT_PAID",
  "PAYMENT_INSTRUMENT_GENERATION_FAILED",
  "PAYMENT_OVERPAID",
  "PAYMENT_UNDERPAID",
  "PAYMENT_PARTIAL_CANCELED",
  "PAYMENT_PAYMENT_FAILED",
  "PAYMENT_PENDING",
  "PAYMENT_PROCESSING",
  "PAYMENT_REFUNDED",
  "PAYMENT_UPDATED",
  "PAYMENT_CHARGEBACK",
] as const
export const CONCILIATION_EVENTS = ["CONCILIATION_FILE_AVAILABLE"] as const
export const EVENT_LABELS: Record<string, string> = {
  PING: "Ping",
  BROKER_CREATED: "Corretor criado",
  BROKER_UPDATED: "Corretor atualizado",
  BROKER_DELETED: "Corretor deletado",
  CUSTOMER_CREATED: "Cliente criado",
  CUSTOMER_UPDATED: "Cliente atualizado",
  CUSTOMER_DELETED: "Cliente deletado",
  ORDER_CREATED: "Pedido criado",
  ORDER_PAID: "Pedido pago",
  ORDER_EXPIRED: "Pedido expirado",
  ORDER_REVERSED: "Pedido estornado",
  ORDER_REVERSE_FAILED: "Falha no estorno do pedido",
  ORDER_REFUNDED: "Pedido reembolsado",
  ORDER_REFUND_FAILED: "Falha no reembolso do pedido",
  ORDER_PARTIAL_REFUNDED: "Pedido parcialmente reembolsado",
  ORDER_FINISHED: "Pedido finalizado",
  ORDER_PAYMENT_FAILED: "Falha no pagamento do pedido",
  SUBSCRIPTION_CREATED: "Assinatura criada",
  SUBSCRIPTION_PAUSE: "Assinatura pausada",
  SUBSCRIPTION_CANCELLED: "Assinatura cancelada",
  SUBSCRIPTION_FINISHED: "Assinatura finalizada",
  SUBSCRIPTION_EXPIRED: "Assinatura expirada",
  SUBSCRIPTION_PAYMENT_METHOD_CHANGED: "Método de pagamento alterado",
  SUBSCRIPTION_CYCLE_PAID: "Ciclo da assinatura pago",
  SUBSCRIPTION_CYCLE_REVERSED: "Ciclo da assinatura estornado",
  SUBSCRIPTION_CYCLE_REVERSE_FAILED: "Falha no estorno do ciclo",
  SUBSCRIPTION_CYCLE_REFUNDED: "Ciclo da assinatura reembolsado",
  SUBSCRIPTION_CYCLE_REFUND_FAILED: "Falha no reembolso do ciclo",
  SUBSCRIPTION_CYCLE_PARTIAL_REFUNDED: "Ciclo parcialmente reembolsado",
  SUBSCRIPTION_CYCLE_CANCELLED: "Ciclo da assinatura cancelado",
  SUBSCRIPTION_CYCLE_SKIPPED: "Ciclo da assinatura pulado",
  SUBSCRIPTION_CYCLE_PAYMENT_FAILED: "Falha no pagamento do ciclo",
  SUBSCRIPTION_CYCLE_WAITING_PAYMENT: "Ciclo aguardando pagamento",
  SUBSCRIPTION_CYCLE_PAYMENT_IDENTIFIED: "Pagamento do ciclo identificado",
  SUBSCRIPTION_CYCLE_PAYMENT_METHOD_CHANGED:
    "Método de pagamento do ciclo alterado",
  ORDER_INSURANCE_CREATED: "Pedido de seguro criado",
  ORDER_INSURANCE_PAID: "Pedido de seguro pago",
  ORDER_INSURANCE_EXPIRED: "Pedido de seguro expirado",
  ORDER_INSURANCE_REVERSED: "Pedido de seguro estornado",
  ORDER_INSURANCE_REVERSE_FAILED: "Falha no estorno do pedido de seguro",
  ORDER_INSURANCE_REFUNDED: "Pedido de seguro reembolsado",
  ORDER_INSURANCE_REFUND_FAILED: "Falha no reembolso do pedido de seguro",
  ORDER_INSURANCE_REFUND_CANCELED: "Reembolso do pedido de seguro cancelado",
  ORDER_INSURANCE_REFUND_PENDING: "Reembolso do pedido de seguro pendente",
  ORDER_INSURANCE_PARTIAL_REFUNDED: "Pedido de seguro parcialmente reembolsado",
  ORDER_INSURANCE_FINISHED: "Pedido de seguro finalizado",
  ORDER_INSURANCE_PAYMENT_FAILED: "Falha no pagamento do pedido de seguro",
  ORDER_INSURANCE_WAITING_PAYMENT: "Pedido de seguro aguardando pagamento",
  ORDER_INSURANCE_PAYMENT_IDENTIFIED:
    "Pagamento do pedido de seguro identificado",
  SUBSCRIPTION_INSURANCE_CREATED: "Assinatura de seguro criada",
  SUBSCRIPTION_INSURANCE_PAUSE: "Assinatura de seguro pausada",
  SUBSCRIPTION_INSURANCE_CANCELLED: "Assinatura de seguro cancelada",
  SUBSCRIPTION_INSURANCE_FINISHED: "Assinatura de seguro finalizada",
  SUBSCRIPTION_INSURANCE_EXPIRED: "Assinatura de seguro expirada",
  SUBSCRIPTION_INSURANCE_PAYMENT_METHOD_CHANGED:
    "Método de pagamento do seguro alterado",
  SUBSCRIPTION_INSURANCE_DELEGATE_REVIEW_EXPIRED:
    "Revisão delegada do seguro expirada",
  SUBSCRIPTION_INSURANCE_DELEGATE_UNDER_REVIEW: "Seguro em revisão delegada",
  SUBSCRIPTION_INSURANCE_CYCLE_PAID: "Ciclo do seguro pago",
  SUBSCRIPTION_INSURANCE_CYCLE_REVERSED: "Ciclo do seguro estornado",
  SUBSCRIPTION_INSURANCE_CYCLE_REVERSE_FAILED:
    "Falha no estorno do ciclo do seguro",
  SUBSCRIPTION_INSURANCE_CYCLE_REFUNDED: "Ciclo do seguro reembolsado",
  SUBSCRIPTION_INSURANCE_CYCLE_REFUND_FAILED:
    "Falha no reembolso do ciclo do seguro",
  SUBSCRIPTION_INSURANCE_CYCLE_PARTIAL_REFUNDED:
    "Ciclo do seguro parcialmente reembolsado",
  SUBSCRIPTION_INSURANCE_CYCLE_CANCELLED: "Ciclo do seguro cancelado",
  SUBSCRIPTION_INSURANCE_CYCLE_SKIPPED: "Ciclo do seguro pulado",
  SUBSCRIPTION_INSURANCE_CYCLE_PAYMENT_FAILED:
    "Falha no pagamento do ciclo do seguro",
  SUBSCRIPTION_INSURANCE_CYCLE_WAITING_PAYMENT:
    "Ciclo do seguro aguardando pagamento",
  SUBSCRIPTION_INSURANCE_CYCLE_PAYMENT_IDENTIFIED:
    "Pagamento do ciclo do seguro identificado",
  SUBSCRIPTION_INSURANCE_CYCLE_PAYMENT_METHOD_CHANGED:
    "Método de pagamento do ciclo do seguro alterado",
  CARD_CREATED: "Cartão criado",
  CARD_UPDATED: "Cartão atualizado",
  CARD_DELETED: "Cartão deletado",
  CARD_EXPIRED: "Cartão expirado",
  PAYMENT_ANTIFRAUD_APPROVED: "Antifraude aprovado",
  PAYMENT_ANTIFRAUD_MANUAL: "Antifraude em análise manual",
  PAYMENT_ANTIFRAUD_PENDING: "Antifraude pendente",
  PAYMENT_ANTIFRAUD_REPROVED: "Antifraude reprovado",
  PAYMENT_CREATED: "Cobrança criada",
  PAYMENT_PAID: "Cobrança paga",
  PAYMENT_INSTRUMENT_GENERATION_FAILED: "Falha na geração do instrumento",
  PAYMENT_OVERPAID: "Cobrança paga a mais",
  PAYMENT_UNDERPAID: "Cobrança paga a menos",
  PAYMENT_PARTIAL_CANCELED: "Cobrança parcialmente cancelada",
  PAYMENT_PAYMENT_FAILED: "Falha no pagamento da cobrança",
  PAYMENT_PENDING: "Cobrança pendente",
  PAYMENT_PROCESSING: "Cobrança em processamento",
  PAYMENT_REFUNDED: "Cobrança reembolsada",
  PAYMENT_UPDATED: "Cobrança atualizada",
  PAYMENT_CHARGEBACK: "Chargeback da cobrança",
  CONCILIATION_FILE_AVAILABLE: "Arquivo de conciliação disponível",
}
export const getEventLabel = (event: string): string => {
  return EVENT_LABELS[event] || event
}
export const STATUS_COLORS: Record<WebhookResourceStatus, string> = {
  PENDING: "bg-yellow-500 text-white",
  SENDING: "bg-blue-500 text-white",
  SENT: "bg-green-500 text-white",
  FAILED: "bg-red-500 text-white",
}
export const STATUS_LABELS: Record<WebhookResourceStatus, string> = {
  PENDING: "Pendente",
  SENDING: "Enviando",
  SENT: "Enviado",
  FAILED: "Falhou",
}
export const ALL_WEBHOOK_EVENTS = [
  ...GENERAL_EVENTS,
  ...ORDER_EVENTS,
  ...SUBSCRIPTION_EVENTS,
  ...SUBSCRIPTION_CYCLE_EVENTS,
  ...ORDER_INSURANCE_EVENTS,
  ...SUBSCRIPTION_INSURANCE_EVENTS,
  ...SUBSCRIPTION_INSURANCE_CYCLE_EVENTS,
  ...CARD_EVENTS,
  ...ANTIFRAUD_EVENTS,
  ...PAYMENT_EVENTS,
  ...CONCILIATION_EVENTS,
] as const
export type WebhookEvent = (typeof ALL_WEBHOOK_EVENTS)[number]
